export default __webpack_public_path__ + "i18n/translations/translation-hi.4c2de6df.json";